import {
  HHAlert,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';

export interface NoRowsProps {
  error: boolean;
  message?: string;
}

export function NoRowsOverlay({
  error,
  message = 'No results found.',
}: NoRowsProps): JSX.Element {
  return (
    <HHStack
      direction="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      bgcolor={(theme): string => theme.palette.background.default}
    >
      {!error ? (
        <HHTypography hhVariant="body1" role="contentinfo">
          {message}
        </HHTypography>
      ) : (
        <HHAlert
          hhVariant="outlined"
          severity="info"
          role="alert"
          children={
            <HHTypography hhVariant="body">
              There was an error fetching data.
            </HHTypography>
          }
        />
      )}
    </HHStack>
  );
}
